// ASCII art assets for Creative Queue branding

export const CQ_LOGO_ASCII = `
 ██████╗  ██████╗
██╔════╝ ██╔═══██╗
██║      ██║   ██║
██║      ██║▄▄ ██║
╚██████╗ ╚██████╔╝
 ╚═════╝  ╚══▀▀═╝ `;

export const CQ_TAGLINE = 'speed is substance.';

export const CQ_INFO_PANEL_ASCII = `
┌─────────────────────────────┐
│  ┌─────────────────────────┐│
│  │  ┌─────────────────────┐││
│  │  │      CQ LOGO        │││
│  │  └─────────────────────┘││
│  └─────────────────────────┘│
└─────────────────────────────┘`;

// Compact logo for smaller displays
export const CQ_LOGO_COMPACT = `
██████╗  ██████╗
██╔════╝ ██╔═══██╗
██║      ██║   ██║
██║      ██║▄▄ ██║
╚██████╗ ╚██████╔╝
 ╚═════╝  ╚══▀▀═╝ `;
